module.exports = __webpack_public_path__ + "static/media/Team 3 - The Green Junkyard.c21f9377.jpeg";